import type { WardrobeItem } from '../api';

export type LowestPrice = { amount: number; perMonth: boolean };

type PriceFields = Pick<WardrobeItem, 'forRent' | 'rentPrice' | 'rentPrice1' | 'rentPrice3' | 'rentPrice24' | 'forSale' | 'salePrice'>;

/**
 * Lägsta pris en annons erbjuder, för "Från X kr" på annonskortet.
 * Hyrespriserna är per månad (1, 3, 12 och 24 månaders bindning) och jämförs
 * rakt mot köppriset. null = inget pris, alltså bara byte.
 */
export function lowestListingPrice(item: PriceFields): LowestPrice | null {
  const candidates: LowestPrice[] = [];
  if (item.forRent) {
    for (const p of [item.rentPrice, item.rentPrice1, item.rentPrice3, item.rentPrice24]) {
      if (p != null && p > 0) candidates.push({ amount: p, perMonth: true });
    }
  }
  if (item.forSale && item.salePrice > 0) candidates.push({ amount: item.salePrice, perMonth: false });
  if (candidates.length === 0) return null;
  // Vid lika pris vinner hyran, eftersom den listas först.
  return candidates.reduce((min, c) => (c.amount < min.amount ? c : min));
}
